<template>
  <div class="timeline-minimap" ref="container">
    <div
      class="timeline-minimap__sequence"
      :style="{
        'left': `${minimapSequenceStart}%`,
        'width': `${minimapSequenceWidth}%`,
      }" />
    <div
      class="timeline-minimap__blackhole"
      v-for="(style, index) in blackholes" :key="index"
      :style="style" />
    <div
      ref="marker"
      class="timeline-minimap__marker"
      :style="{
        'left': `${minimapMarkerPos}%`,
      }" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    /* eslint-disable */
    ...mapState({
      playheadTimelineTime: (state) => state.stream.playheadTimelineTime,
      timelineDuration: (state) => state.stream.timelineDuration,
      markInTimelineTime: (state) => state.stream.markInTimelineTime,
      markOutTimelineTime: (state) => state.stream.markOutTimelineTime,
      blackholeTimelines: (state) => state.stream.blackholeTimelines,
      /* eslint-enable */
    }),
    ...mapGetters({
      playheadProgramDateTime: 'playheadProgramDateTime',
    }),
    minimapMarkerPos() {
      return this.playheadTimelineTime / this.timelineDuration * 100;
    },
    minimapSequenceStart() {
      return this.markInTimelineTime / this.timelineDuration * 100;
    },
    minimapSequenceWidth() {
      return (this.markOutTimelineTime - this.markInTimelineTime) / this.timelineDuration * 100;
    },
    blackholes() {
      return this.blackholeTimelines.map(
        timeline => ({
          left: `${timeline.startTimelineTime / this.timelineDuration * 100}%`,
          width: `${timeline.duration / this.timelineDuration * 100}%`,
        }),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/variables.scss';

.timeline-minimap {
  position: relative;
  bottom: 0;
  left: 0;
  height: 1em;
  width: 100%;
  margin-top: -1em;
  cursor: grab;
  pointer-events: none;
  background-color: rgba(0, 0, 0, .1);

  .timeline-minimap__sequence {
    position: absolute;
    height: 1em;
    background-color: #9BA4B4;
    top: 0;
    transition: all .3s ease-in-out;
    z-index: 1;
  }

  .timeline-minimap__blackhole {
    position: absolute;
    height: 1em;
    background: repeating-linear-gradient(
      45deg,
      rgba(0, 0, 0, .3),
      rgba(0, 0, 0, .3) 10px,
      rgba(0, 0, 0, .1) 10px,
      rgba(0, 0, 0, .1) 20px
    );
    top: 0;
    z-index: 2;
  }

  .timeline-minimap__marker {
    position: absolute;
    background-color: $primary;
    height: 1em;
    width: 2px;
    transition: all .1s ease-in-out;
    z-index: 3;
  }
}
</style>
